import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
};

export type Catalog = {
  __typename?: 'Catalog';
  catalogId: Scalars['ID'];
  companyId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  pdf?: Maybe<Scalars['String']>;
  publishDate: Scalars['DateTime'];
  salesPoint?: Maybe<Scalars['String']>;
  thumbnailUrls?: Maybe<Array<Maybe<ThumbnailUrls>>>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CatalogRelateQueryInput = {
  companyId: Scalars['String'];
};

export type CatalogRelateWhereParamsInput = {
  cursor?: InputMaybe<CatalogRelateQueryInput>;
  limit: Scalars['Float'];
  orderBy: Scalars['String'];
  skip: Scalars['Float'];
  where?: InputMaybe<CatalogRelateQueryInput>;
};

export type CatalogWhereParamsInput = {
  cursor?: InputMaybe<CatalogsSearchQueryInput>;
  limit: Scalars['Float'];
  orderBy: Scalars['String'];
  skip: Scalars['Float'];
  where?: InputMaybe<CatalogsSearchQueryInput>;
};

export type CatalogWhereUniqueInput = {
  catalogId: Scalars['String'];
  companyId: Scalars['String'];
};

export type CatalogWithCategoryAndCompany = {
  __typename?: 'CatalogWithCategoryAndCompany';
  catalogId: Scalars['ID'];
  category: Category;
  company: CompanyInfo;
  companyId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  pdf?: Maybe<Scalars['String']>;
  publishDate: Scalars['DateTime'];
  salesPoint?: Maybe<Scalars['String']>;
  thumbnailUrls?: Maybe<Array<Maybe<ThumbnailUrls>>>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CatalogWithCompany = {
  __typename?: 'CatalogWithCompany';
  catalogId: Scalars['ID'];
  company: CompanyInfo;
  companyId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  pdf?: Maybe<Scalars['String']>;
  publishDate: Scalars['DateTime'];
  salesPoint?: Maybe<Scalars['String']>;
  thumbnailUrls?: Maybe<Array<Maybe<ThumbnailUrls>>>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CatalogsSearchQueryInput = {
  catalogIds?: InputMaybe<Array<Scalars['String']>>;
  firstDepthCategoryId?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Platform>;
  secondDepthCategoryId?: InputMaybe<Scalars['String']>;
  thirdDepthCategoryId?: InputMaybe<Scalars['String']>;
};

export type CategoriesFirstCategoryWhereParamsInput = {
  cursor?: InputMaybe<CategoryWhereCatalogParamsInput>;
  limit: Scalars['Float'];
  orderBy: OrderBy;
  skip: Scalars['Float'];
  where?: InputMaybe<CategoriesWhereCatalogParamsInput>;
};

export type CategoriesWhereCatalogParamsInput = {
  catalogIds?: InputMaybe<Array<Scalars['String']>>;
  platform?: InputMaybe<Platform>;
};

export type Category = {
  __typename?: 'Category';
  firstDepth?: Maybe<FirstDepthCategory>;
  secondDepth?: Maybe<SecondDepthCategory>;
  thirdDepth?: Maybe<ThirdDepthCategory>;
};

export type CategoryWhereCatalogParamsInput = {
  makerIds?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Float']>;
};

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  catalogLength?: Maybe<Scalars['Float']>;
  companyId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameKana?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};

export type CompanyInfoWhereParamsInput = {
  cursor?: InputMaybe<CompanyInfoWhereUniqueInput>;
  limit: Scalars['Float'];
  orderBy: Scalars['String'];
  skip: Scalars['Float'];
  where?: InputMaybe<CompanyInfoWhereUniqueInput>;
};

export type CompanyInfoWhereUniqueInput = {
  catalogListLength?: InputMaybe<Scalars['Float']>;
  catalogListSkip?: InputMaybe<Scalars['Float']>;
  companyId: Scalars['String'];
};

export type CompanyInfoWithCatalogs = {
  __typename?: 'CompanyInfoWithCatalogs';
  catalogLength?: Maybe<Scalars['Float']>;
  catalogs: Array<Catalog>;
  companyId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameKana?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};

export type FirstDepthCategory = {
  __typename?: 'FirstDepthCategory';
  catalogLength: Scalars['Float'];
  catalogs: Array<Maybe<CatalogWithCompany>>;
  categoryId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  length: Scalars['Float'];
  level?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  secondDepthCategories?: Maybe<Array<Maybe<SecondDepthCategory>>>;
};

export type FirstDepthCategoryWhereUniqueInput = {
  firstDepthCategoryId: Scalars['String'];
};

export enum OrderBy {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Platform {
  Chematels = 'chematels',
  Coataz = 'coataz',
  Plabase = 'plabase'
}

export type Query = {
  __typename?: 'Query';
  catalog?: Maybe<CatalogWithCategoryAndCompany>;
  catalogs: Array<Maybe<CatalogWithCompany>>;
  catalogsRelate: Array<Maybe<CatalogWithCompany>>;
  companies: Array<Maybe<CompanyInfo>>;
  company?: Maybe<CompanyInfoWithCatalogs>;
  firstDepthCategories: Array<FirstDepthCategory>;
  firstDepthCategory?: Maybe<FirstDepthCategory>;
  pickupCatalogs: Array<Maybe<CatalogWithCompany>>;
  secondDepthCategories: Array<SecondDepthCategory>;
  secondDepthCategory?: Maybe<SecondDepthCategory>;
  thirdDepthCategories: Array<ThirdDepthCategory>;
  thirdDepthCategory?: Maybe<ThirdDepthCategory>;
};


export type QueryCatalogArgs = {
  args: CatalogWhereUniqueInput;
};


export type QueryCatalogsArgs = {
  args: CatalogWhereParamsInput;
};


export type QueryCatalogsRelateArgs = {
  args: CatalogRelateWhereParamsInput;
};


export type QueryCompaniesArgs = {
  args: CompanyInfoWhereParamsInput;
};


export type QueryCompanyArgs = {
  args: CompanyInfoWhereUniqueInput;
};


export type QueryFirstDepthCategoriesArgs = {
  args?: InputMaybe<CategoriesFirstCategoryWhereParamsInput>;
};


export type QueryFirstDepthCategoryArgs = {
  args: FirstDepthCategoryWhereUniqueInput;
  catalogWhere?: InputMaybe<CategoryWhereCatalogParamsInput>;
};


export type QueryPickupCatalogsArgs = {
  args: CatalogWhereParamsInput;
};


export type QuerySecondDepthCategoryArgs = {
  args: SecondDepthCategoryWhereUniqueInput;
  catalogWhere?: InputMaybe<CategoryWhereCatalogParamsInput>;
};


export type QueryThirdDepthCategoryArgs = {
  args: ThirdDepthCategoryWhereUniqueInput;
  catalogWhere?: InputMaybe<CategoryWhereCatalogParamsInput>;
};

export type SecondDepthCategory = {
  __typename?: 'SecondDepthCategory';
  catalogLength: Scalars['Float'];
  catalogs: Array<Maybe<CatalogWithCompany>>;
  categoryId?: Maybe<Scalars['ID']>;
  companies: Array<Maybe<CompanyInfo>>;
  description?: Maybe<Scalars['String']>;
  firstDepthCategoryId: Scalars['String'];
  firstDepthCategoryLength: Scalars['Float'];
  firstDepthCategoryName: Scalars['String'];
  length: Scalars['Float'];
  level?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  thirdDepthCategories?: Maybe<Array<Maybe<ThirdDepthCategory>>>;
};

export type SecondDepthCategoryWhereUniqueInput = {
  firstDepthCategoryId: Scalars['String'];
  secondDepthCategoryId: Scalars['String'];
};

export type ThirdDepthCategory = {
  __typename?: 'ThirdDepthCategory';
  catalogLength: Scalars['Float'];
  catalogs: Array<CatalogWithCompany>;
  categoryId?: Maybe<Scalars['ID']>;
  companies: Array<CompanyInfo>;
  description?: Maybe<Scalars['String']>;
  firstDepthCategoryId: Scalars['String'];
  firstDepthCategoryLength: Scalars['Float'];
  firstDepthCategoryName: Scalars['String'];
  length: Scalars['Float'];
  level?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  secondDepthCategoryId: Scalars['String'];
  secondDepthCategoryLength: Scalars['Float'];
  secondDepthCategoryName: Scalars['String'];
};

export type ThirdDepthCategoryWhereUniqueInput = {
  firstDepthCategoryId: Scalars['String'];
  secondDepthCategoryId: Scalars['String'];
  thirdDepthCategoryId: Scalars['String'];
};

export type ThumbnailUrls = {
  __typename?: 'ThumbnailUrls';
  fileName: Scalars['String'];
  url: Scalars['String'];
};

export type CatalogFragment = { __typename?: 'CatalogWithCategoryAndCompany', catalogId: string, companyId: string, title?: string | null, salesPoint?: string | null, description?: string | null, pdf?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, category: { __typename?: 'Category', firstDepth?: { __typename?: 'FirstDepthCategory', categoryId?: string | null, name?: string | null, description?: string | null, level?: number | null } | null, secondDepth?: { __typename?: 'SecondDepthCategory', categoryId?: string | null, name?: string | null, description?: string | null, level?: number | null } | null, thirdDepth?: { __typename?: 'ThirdDepthCategory', categoryId?: string | null, name?: string | null, description?: string | null, level?: number | null } | null }, company: { __typename?: 'CompanyInfo', companyId: string, name?: string | null, nameKana?: string | null, url?: string | null, description?: string | null } };

export type GetCatalogQueryVariables = Exact<{
  args: CatalogWhereUniqueInput;
}>;


export type GetCatalogQuery = { __typename?: 'Query', catalog?: { __typename?: 'CatalogWithCategoryAndCompany', catalogId: string, companyId: string, title?: string | null, salesPoint?: string | null, description?: string | null, pdf?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, category: { __typename?: 'Category', firstDepth?: { __typename?: 'FirstDepthCategory', categoryId?: string | null, name?: string | null, description?: string | null, level?: number | null } | null, secondDepth?: { __typename?: 'SecondDepthCategory', categoryId?: string | null, name?: string | null, description?: string | null, level?: number | null } | null, thirdDepth?: { __typename?: 'ThirdDepthCategory', categoryId?: string | null, name?: string | null, description?: string | null, level?: number | null } | null }, company: { __typename?: 'CompanyInfo', companyId: string, name?: string | null, nameKana?: string | null, url?: string | null, description?: string | null } } | null };

export type CatalogContactFragment = { __typename?: 'CatalogWithCategoryAndCompany', catalogId: string, companyId: string, title?: string | null };

export type GetCatalogContactQueryVariables = Exact<{
  args: CatalogWhereUniqueInput;
}>;


export type GetCatalogContactQuery = { __typename?: 'Query', catalog?: { __typename?: 'CatalogWithCategoryAndCompany', catalogId: string, companyId: string, title?: string | null } | null };

export type CatalogTopFragment = { __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', name?: string | null } };

export type GetCatalogTopQueryVariables = Exact<{
  args: CatalogWhereParamsInput;
  categoryArgs?: InputMaybe<CategoriesFirstCategoryWhereParamsInput>;
}>;


export type GetCatalogTopQuery = { __typename?: 'Query', catalogs: Array<{ __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', name?: string | null } } | null>, pickupCatalogs: Array<{ __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', name?: string | null } } | null>, firstDepthCategories: Array<{ __typename?: 'FirstDepthCategory', categoryId?: string | null, name?: string | null, length: number }> };

export type CatalogsFragment = { __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', name?: string | null } };

export type GetCatalogsQueryVariables = Exact<{
  args: CatalogWhereParamsInput;
}>;


export type GetCatalogsQuery = { __typename?: 'Query', catalogs: Array<{ __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', name?: string | null } } | null> };

export type GetCompaniesQueryVariables = Exact<{
  args: CompanyInfoWhereParamsInput;
}>;


export type GetCompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'CompanyInfo', companyId: string, name?: string | null } | null> };

export type CompanyInfoFragment = { __typename?: 'CompanyInfoWithCatalogs', companyId: string, name?: string | null, nameKana?: string | null, url?: string | null, description?: string | null, catalogLength?: number | null, catalogs: Array<{ __typename?: 'Catalog', catalogId: string, companyId: string, title?: string | null, createdAt: any, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null }> };

export type GetCompanyInfoQueryVariables = Exact<{
  args: CompanyInfoWhereUniqueInput;
}>;


export type GetCompanyInfoQuery = { __typename?: 'Query', company?: { __typename?: 'CompanyInfoWithCatalogs', companyId: string, name?: string | null, nameKana?: string | null, url?: string | null, description?: string | null, catalogLength?: number | null, catalogs: Array<{ __typename?: 'Catalog', catalogId: string, companyId: string, title?: string | null, createdAt: any, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null }> } | null };

export type FirstDepthCatalogCategoriesFragment = { __typename?: 'FirstDepthCategory', categoryId?: string | null, name?: string | null, length: number };

export type GetFirstDepthCategoriesQueryVariables = Exact<{
  args?: InputMaybe<CategoriesFirstCategoryWhereParamsInput>;
}>;


export type GetFirstDepthCategoriesQuery = { __typename?: 'Query', firstDepthCategories: Array<{ __typename?: 'FirstDepthCategory', categoryId?: string | null, name?: string | null, length: number }> };

export type FirstDepthCatalogCategoryFragment = { __typename?: 'FirstDepthCategory', categoryId?: string | null, name?: string | null, description?: string | null, length: number, level?: number | null, catalogs: Array<{ __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, salesPoint?: string | null, description?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', companyId: string, name?: string | null } } | null>, secondDepthCategories?: Array<{ __typename?: 'SecondDepthCategory', categoryId?: string | null, name?: string | null, length: number } | null> | null };

export type GetFirstDepthCategoryQueryVariables = Exact<{
  args: FirstDepthCategoryWhereUniqueInput;
  catalogWhere?: InputMaybe<CategoryWhereCatalogParamsInput>;
}>;


export type GetFirstDepthCategoryQuery = { __typename?: 'Query', firstDepthCategory?: { __typename?: 'FirstDepthCategory', categoryId?: string | null, name?: string | null, description?: string | null, length: number, level?: number | null, catalogs: Array<{ __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, salesPoint?: string | null, description?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', companyId: string, name?: string | null } } | null>, secondDepthCategories?: Array<{ __typename?: 'SecondDepthCategory', categoryId?: string | null, name?: string | null, length: number } | null> | null } | null };

export type PickupCatalogTopFragment = { __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', name?: string | null } };

export type GetPickupCatalogsQueryVariables = Exact<{
  args: CatalogWhereParamsInput;
}>;


export type GetPickupCatalogsQuery = { __typename?: 'Query', pickupCatalogs: Array<{ __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', name?: string | null } } | null> };

export type RelateCatalogFragment = { __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', name?: string | null } };

export type GetRelateCatalogsQueryVariables = Exact<{
  args: CatalogRelateWhereParamsInput;
}>;


export type GetRelateCatalogsQuery = { __typename?: 'Query', catalogsRelate: Array<{ __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', name?: string | null } } | null> };

export type SecondDepthCatalogCategoriesFragment = { __typename?: 'SecondDepthCategory', categoryId?: string | null, firstDepthCategoryId: string };

export type GetSecondDepthCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSecondDepthCategoriesQuery = { __typename?: 'Query', secondDepthCategories: Array<{ __typename?: 'SecondDepthCategory', categoryId?: string | null, firstDepthCategoryId: string }> };

export type SecondDepthCatalogCategoryFragment = { __typename?: 'SecondDepthCategory', categoryId?: string | null, firstDepthCategoryId: string, firstDepthCategoryName: string, firstDepthCategoryLength: number, name?: string | null, description?: string | null, length: number, level?: number | null, catalogLength: number, companies: Array<{ __typename?: 'CompanyInfo', companyId: string, name?: string | null } | null>, catalogs: Array<{ __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, salesPoint?: string | null, description?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', companyId: string, name?: string | null } } | null>, thirdDepthCategories?: Array<{ __typename?: 'ThirdDepthCategory', categoryId?: string | null, name?: string | null, length: number } | null> | null };

export type GetSecondDepthCategoryQueryVariables = Exact<{
  args: SecondDepthCategoryWhereUniqueInput;
  catalogWhere?: InputMaybe<CategoryWhereCatalogParamsInput>;
}>;


export type GetSecondDepthCategoryQuery = { __typename?: 'Query', secondDepthCategory?: { __typename?: 'SecondDepthCategory', categoryId?: string | null, firstDepthCategoryId: string, firstDepthCategoryName: string, firstDepthCategoryLength: number, name?: string | null, description?: string | null, length: number, level?: number | null, catalogLength: number, companies: Array<{ __typename?: 'CompanyInfo', companyId: string, name?: string | null } | null>, catalogs: Array<{ __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, salesPoint?: string | null, description?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', companyId: string, name?: string | null } } | null>, thirdDepthCategories?: Array<{ __typename?: 'ThirdDepthCategory', categoryId?: string | null, name?: string | null, length: number } | null> | null } | null };

export type ThirdDepthCatalogCategoriesFragment = { __typename?: 'ThirdDepthCategory', categoryId?: string | null, firstDepthCategoryId: string, secondDepthCategoryId: string };

export type GetThirdDepthCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetThirdDepthCategoriesQuery = { __typename?: 'Query', thirdDepthCategories: Array<{ __typename?: 'ThirdDepthCategory', categoryId?: string | null, firstDepthCategoryId: string, secondDepthCategoryId: string }> };

export type ThirdDepthCatalogCategoryFragment = { __typename?: 'ThirdDepthCategory', categoryId?: string | null, firstDepthCategoryId: string, firstDepthCategoryName: string, firstDepthCategoryLength: number, secondDepthCategoryId: string, secondDepthCategoryName: string, secondDepthCategoryLength: number, name?: string | null, description?: string | null, length: number, level?: number | null, catalogLength: number, companies: Array<{ __typename?: 'CompanyInfo', companyId: string, name?: string | null }>, catalogs: Array<{ __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, salesPoint?: string | null, description?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', companyId: string, name?: string | null } }> };

export type GetThirdDepthCategoryQueryVariables = Exact<{
  args: ThirdDepthCategoryWhereUniqueInput;
  catalogWhere?: InputMaybe<CategoryWhereCatalogParamsInput>;
}>;


export type GetThirdDepthCategoryQuery = { __typename?: 'Query', thirdDepthCategory?: { __typename?: 'ThirdDepthCategory', categoryId?: string | null, firstDepthCategoryId: string, firstDepthCategoryName: string, firstDepthCategoryLength: number, secondDepthCategoryId: string, secondDepthCategoryName: string, secondDepthCategoryLength: number, name?: string | null, description?: string | null, length: number, level?: number | null, catalogLength: number, companies: Array<{ __typename?: 'CompanyInfo', companyId: string, name?: string | null }>, catalogs: Array<{ __typename?: 'CatalogWithCompany', catalogId: string, companyId: string, title?: string | null, salesPoint?: string | null, description?: string | null, thumbnailUrls?: Array<{ __typename?: 'ThumbnailUrls', url: string } | null> | null, company: { __typename?: 'CompanyInfo', companyId: string, name?: string | null } }> } | null };

export const CatalogFragmentDoc = gql`
    fragment Catalog on CatalogWithCategoryAndCompany {
  catalogId
  companyId
  title
  salesPoint
  description
  thumbnailUrls {
    url
  }
  pdf
  category {
    firstDepth {
      categoryId
      name
      description
      level
    }
    secondDepth {
      categoryId
      name
      description
      level
    }
    thirdDepth {
      categoryId
      name
      description
      level
    }
  }
  company {
    companyId
    name
    nameKana
    url
    description
  }
}
    `;
export const CatalogContactFragmentDoc = gql`
    fragment CatalogContact on CatalogWithCategoryAndCompany {
  catalogId
  companyId
  title
}
    `;
export const CatalogTopFragmentDoc = gql`
    fragment CatalogTop on CatalogWithCompany {
  catalogId
  companyId
  title
  thumbnailUrls {
    url
  }
  company {
    name
  }
}
    `;
export const CatalogsFragmentDoc = gql`
    fragment Catalogs on CatalogWithCompany {
  catalogId
  companyId
  title
  thumbnailUrls {
    url
  }
  company {
    name
  }
}
    `;
export const CompanyInfoFragmentDoc = gql`
    fragment CompanyInfo on CompanyInfoWithCatalogs {
  companyId
  name
  nameKana
  url
  description
  catalogs {
    catalogId
    companyId
    title
    thumbnailUrls {
      url
    }
    createdAt
  }
  catalogLength
}
    `;
export const FirstDepthCatalogCategoriesFragmentDoc = gql`
    fragment FirstDepthCatalogCategories on FirstDepthCategory {
  categoryId
  name
  length
}
    `;
export const FirstDepthCatalogCategoryFragmentDoc = gql`
    fragment FirstDepthCatalogCategory on FirstDepthCategory {
  categoryId
  name
  description
  length
  level
  catalogs {
    catalogId
    companyId
    title
    salesPoint
    description
    thumbnailUrls {
      url
    }
    company {
      companyId
      name
    }
  }
  secondDepthCategories {
    categoryId
    name
    length
  }
}
    `;
export const PickupCatalogTopFragmentDoc = gql`
    fragment PickupCatalogTop on CatalogWithCompany {
  catalogId
  companyId
  title
  thumbnailUrls {
    url
  }
  company {
    name
  }
}
    `;
export const RelateCatalogFragmentDoc = gql`
    fragment RelateCatalog on CatalogWithCompany {
  catalogId
  companyId
  title
  thumbnailUrls {
    url
  }
  company {
    name
  }
}
    `;
export const SecondDepthCatalogCategoriesFragmentDoc = gql`
    fragment SecondDepthCatalogCategories on SecondDepthCategory {
  categoryId
  firstDepthCategoryId
}
    `;
export const SecondDepthCatalogCategoryFragmentDoc = gql`
    fragment SecondDepthCatalogCategory on SecondDepthCategory {
  categoryId
  firstDepthCategoryId
  firstDepthCategoryName
  firstDepthCategoryLength
  name
  description
  length
  level
  companies {
    companyId
    name
  }
  catalogs {
    catalogId
    companyId
    title
    salesPoint
    description
    thumbnailUrls {
      url
    }
    company {
      companyId
      name
    }
  }
  catalogLength
  thirdDepthCategories {
    categoryId
    name
    length
  }
}
    `;
export const ThirdDepthCatalogCategoriesFragmentDoc = gql`
    fragment ThirdDepthCatalogCategories on ThirdDepthCategory {
  categoryId
  firstDepthCategoryId
  secondDepthCategoryId
}
    `;
export const ThirdDepthCatalogCategoryFragmentDoc = gql`
    fragment ThirdDepthCatalogCategory on ThirdDepthCategory {
  categoryId
  firstDepthCategoryId
  firstDepthCategoryName
  firstDepthCategoryLength
  secondDepthCategoryId
  secondDepthCategoryName
  secondDepthCategoryLength
  name
  description
  length
  level
  companies {
    companyId
    name
  }
  catalogs {
    catalogId
    companyId
    title
    salesPoint
    description
    thumbnailUrls {
      url
    }
    company {
      companyId
      name
    }
  }
  catalogLength
}
    `;
export const GetCatalogDocument = gql`
    query getCatalog($args: CatalogWhereUniqueInput!) @api(name: cloud) {
  catalog(args: $args) {
    ...Catalog
  }
}
    ${CatalogFragmentDoc}`;

/**
 * __useGetCatalogQuery__
 *
 * To run a query within a React component, call `useGetCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetCatalogQuery(baseOptions: Apollo.QueryHookOptions<GetCatalogQuery, GetCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCatalogQuery, GetCatalogQueryVariables>(GetCatalogDocument, options);
      }
export function useGetCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogQuery, GetCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCatalogQuery, GetCatalogQueryVariables>(GetCatalogDocument, options);
        }
export type GetCatalogQueryHookResult = ReturnType<typeof useGetCatalogQuery>;
export type GetCatalogLazyQueryHookResult = ReturnType<typeof useGetCatalogLazyQuery>;
export type GetCatalogQueryResult = Apollo.QueryResult<GetCatalogQuery, GetCatalogQueryVariables>;
export const GetCatalogContactDocument = gql`
    query getCatalogContact($args: CatalogWhereUniqueInput!) @api(name: cloud) {
  catalog(args: $args) {
    ...CatalogContact
  }
}
    ${CatalogContactFragmentDoc}`;

/**
 * __useGetCatalogContactQuery__
 *
 * To run a query within a React component, call `useGetCatalogContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogContactQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetCatalogContactQuery(baseOptions: Apollo.QueryHookOptions<GetCatalogContactQuery, GetCatalogContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCatalogContactQuery, GetCatalogContactQueryVariables>(GetCatalogContactDocument, options);
      }
export function useGetCatalogContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogContactQuery, GetCatalogContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCatalogContactQuery, GetCatalogContactQueryVariables>(GetCatalogContactDocument, options);
        }
export type GetCatalogContactQueryHookResult = ReturnType<typeof useGetCatalogContactQuery>;
export type GetCatalogContactLazyQueryHookResult = ReturnType<typeof useGetCatalogContactLazyQuery>;
export type GetCatalogContactQueryResult = Apollo.QueryResult<GetCatalogContactQuery, GetCatalogContactQueryVariables>;
export const GetCatalogTopDocument = gql`
    query getCatalogTop($args: CatalogWhereParamsInput!, $categoryArgs: CategoriesFirstCategoryWhereParamsInput) @api(name: cloud) {
  catalogs(args: $args) {
    ...CatalogTop
  }
  pickupCatalogs(args: $args) {
    ...CatalogTop
  }
  firstDepthCategories(args: $categoryArgs) {
    categoryId
    name
    length
  }
}
    ${CatalogTopFragmentDoc}`;

/**
 * __useGetCatalogTopQuery__
 *
 * To run a query within a React component, call `useGetCatalogTopQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogTopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogTopQuery({
 *   variables: {
 *      args: // value for 'args'
 *      categoryArgs: // value for 'categoryArgs'
 *   },
 * });
 */
export function useGetCatalogTopQuery(baseOptions: Apollo.QueryHookOptions<GetCatalogTopQuery, GetCatalogTopQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCatalogTopQuery, GetCatalogTopQueryVariables>(GetCatalogTopDocument, options);
      }
export function useGetCatalogTopLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogTopQuery, GetCatalogTopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCatalogTopQuery, GetCatalogTopQueryVariables>(GetCatalogTopDocument, options);
        }
export type GetCatalogTopQueryHookResult = ReturnType<typeof useGetCatalogTopQuery>;
export type GetCatalogTopLazyQueryHookResult = ReturnType<typeof useGetCatalogTopLazyQuery>;
export type GetCatalogTopQueryResult = Apollo.QueryResult<GetCatalogTopQuery, GetCatalogTopQueryVariables>;
export const GetCatalogsDocument = gql`
    query getCatalogs($args: CatalogWhereParamsInput!) @api(name: cloud) {
  catalogs(args: $args) {
    ...Catalogs
  }
}
    ${CatalogsFragmentDoc}`;

/**
 * __useGetCatalogsQuery__
 *
 * To run a query within a React component, call `useGetCatalogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetCatalogsQuery(baseOptions: Apollo.QueryHookOptions<GetCatalogsQuery, GetCatalogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCatalogsQuery, GetCatalogsQueryVariables>(GetCatalogsDocument, options);
      }
export function useGetCatalogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogsQuery, GetCatalogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCatalogsQuery, GetCatalogsQueryVariables>(GetCatalogsDocument, options);
        }
export type GetCatalogsQueryHookResult = ReturnType<typeof useGetCatalogsQuery>;
export type GetCatalogsLazyQueryHookResult = ReturnType<typeof useGetCatalogsLazyQuery>;
export type GetCatalogsQueryResult = Apollo.QueryResult<GetCatalogsQuery, GetCatalogsQueryVariables>;
export const GetCompaniesDocument = gql`
    query getCompanies($args: CompanyInfoWhereParamsInput!) @api(name: cloud) {
  companies(args: $args) {
    companyId
    name
  }
}
    `;

/**
 * __useGetCompaniesQuery__
 *
 * To run a query within a React component, call `useGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
      }
export function useGetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
        }
export type GetCompaniesQueryHookResult = ReturnType<typeof useGetCompaniesQuery>;
export type GetCompaniesLazyQueryHookResult = ReturnType<typeof useGetCompaniesLazyQuery>;
export type GetCompaniesQueryResult = Apollo.QueryResult<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const GetCompanyInfoDocument = gql`
    query getCompanyInfo($args: CompanyInfoWhereUniqueInput!) @api(name: cloud) {
  company(args: $args) {
    ...CompanyInfo
  }
}
    ${CompanyInfoFragmentDoc}`;

/**
 * __useGetCompanyInfoQuery__
 *
 * To run a query within a React component, call `useGetCompanyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInfoQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetCompanyInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>(GetCompanyInfoDocument, options);
      }
export function useGetCompanyInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>(GetCompanyInfoDocument, options);
        }
export type GetCompanyInfoQueryHookResult = ReturnType<typeof useGetCompanyInfoQuery>;
export type GetCompanyInfoLazyQueryHookResult = ReturnType<typeof useGetCompanyInfoLazyQuery>;
export type GetCompanyInfoQueryResult = Apollo.QueryResult<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>;
export const GetFirstDepthCategoriesDocument = gql`
    query getFirstDepthCategories($args: CategoriesFirstCategoryWhereParamsInput) @api(name: cloud) {
  firstDepthCategories(args: $args) {
    ...FirstDepthCatalogCategories
  }
}
    ${FirstDepthCatalogCategoriesFragmentDoc}`;

/**
 * __useGetFirstDepthCategoriesQuery__
 *
 * To run a query within a React component, call `useGetFirstDepthCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirstDepthCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirstDepthCategoriesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetFirstDepthCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetFirstDepthCategoriesQuery, GetFirstDepthCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirstDepthCategoriesQuery, GetFirstDepthCategoriesQueryVariables>(GetFirstDepthCategoriesDocument, options);
      }
export function useGetFirstDepthCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirstDepthCategoriesQuery, GetFirstDepthCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirstDepthCategoriesQuery, GetFirstDepthCategoriesQueryVariables>(GetFirstDepthCategoriesDocument, options);
        }
export type GetFirstDepthCategoriesQueryHookResult = ReturnType<typeof useGetFirstDepthCategoriesQuery>;
export type GetFirstDepthCategoriesLazyQueryHookResult = ReturnType<typeof useGetFirstDepthCategoriesLazyQuery>;
export type GetFirstDepthCategoriesQueryResult = Apollo.QueryResult<GetFirstDepthCategoriesQuery, GetFirstDepthCategoriesQueryVariables>;
export const GetFirstDepthCategoryDocument = gql`
    query getFirstDepthCategory($args: FirstDepthCategoryWhereUniqueInput!, $catalogWhere: CategoryWhereCatalogParamsInput) @api(name: cloud) {
  firstDepthCategory(args: $args, catalogWhere: $catalogWhere) {
    ...FirstDepthCatalogCategory
  }
}
    ${FirstDepthCatalogCategoryFragmentDoc}`;

/**
 * __useGetFirstDepthCategoryQuery__
 *
 * To run a query within a React component, call `useGetFirstDepthCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirstDepthCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirstDepthCategoryQuery({
 *   variables: {
 *      args: // value for 'args'
 *      catalogWhere: // value for 'catalogWhere'
 *   },
 * });
 */
export function useGetFirstDepthCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetFirstDepthCategoryQuery, GetFirstDepthCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirstDepthCategoryQuery, GetFirstDepthCategoryQueryVariables>(GetFirstDepthCategoryDocument, options);
      }
export function useGetFirstDepthCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirstDepthCategoryQuery, GetFirstDepthCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirstDepthCategoryQuery, GetFirstDepthCategoryQueryVariables>(GetFirstDepthCategoryDocument, options);
        }
export type GetFirstDepthCategoryQueryHookResult = ReturnType<typeof useGetFirstDepthCategoryQuery>;
export type GetFirstDepthCategoryLazyQueryHookResult = ReturnType<typeof useGetFirstDepthCategoryLazyQuery>;
export type GetFirstDepthCategoryQueryResult = Apollo.QueryResult<GetFirstDepthCategoryQuery, GetFirstDepthCategoryQueryVariables>;
export const GetPickupCatalogsDocument = gql`
    query getPickupCatalogs($args: CatalogWhereParamsInput!) @api(name: cloud) {
  pickupCatalogs(args: $args) {
    ...PickupCatalogTop
  }
}
    ${PickupCatalogTopFragmentDoc}`;

/**
 * __useGetPickupCatalogsQuery__
 *
 * To run a query within a React component, call `useGetPickupCatalogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPickupCatalogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPickupCatalogsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetPickupCatalogsQuery(baseOptions: Apollo.QueryHookOptions<GetPickupCatalogsQuery, GetPickupCatalogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPickupCatalogsQuery, GetPickupCatalogsQueryVariables>(GetPickupCatalogsDocument, options);
      }
export function useGetPickupCatalogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPickupCatalogsQuery, GetPickupCatalogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPickupCatalogsQuery, GetPickupCatalogsQueryVariables>(GetPickupCatalogsDocument, options);
        }
export type GetPickupCatalogsQueryHookResult = ReturnType<typeof useGetPickupCatalogsQuery>;
export type GetPickupCatalogsLazyQueryHookResult = ReturnType<typeof useGetPickupCatalogsLazyQuery>;
export type GetPickupCatalogsQueryResult = Apollo.QueryResult<GetPickupCatalogsQuery, GetPickupCatalogsQueryVariables>;
export const GetRelateCatalogsDocument = gql`
    query getRelateCatalogs($args: CatalogRelateWhereParamsInput!) @api(name: cloud) {
  catalogsRelate(args: $args) {
    ...RelateCatalog
  }
}
    ${RelateCatalogFragmentDoc}`;

/**
 * __useGetRelateCatalogsQuery__
 *
 * To run a query within a React component, call `useGetRelateCatalogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelateCatalogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelateCatalogsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetRelateCatalogsQuery(baseOptions: Apollo.QueryHookOptions<GetRelateCatalogsQuery, GetRelateCatalogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelateCatalogsQuery, GetRelateCatalogsQueryVariables>(GetRelateCatalogsDocument, options);
      }
export function useGetRelateCatalogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelateCatalogsQuery, GetRelateCatalogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelateCatalogsQuery, GetRelateCatalogsQueryVariables>(GetRelateCatalogsDocument, options);
        }
export type GetRelateCatalogsQueryHookResult = ReturnType<typeof useGetRelateCatalogsQuery>;
export type GetRelateCatalogsLazyQueryHookResult = ReturnType<typeof useGetRelateCatalogsLazyQuery>;
export type GetRelateCatalogsQueryResult = Apollo.QueryResult<GetRelateCatalogsQuery, GetRelateCatalogsQueryVariables>;
export const GetSecondDepthCategoriesDocument = gql`
    query getSecondDepthCategories @api(name: cloud) {
  secondDepthCategories {
    ...SecondDepthCatalogCategories
  }
}
    ${SecondDepthCatalogCategoriesFragmentDoc}`;

/**
 * __useGetSecondDepthCategoriesQuery__
 *
 * To run a query within a React component, call `useGetSecondDepthCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSecondDepthCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSecondDepthCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSecondDepthCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetSecondDepthCategoriesQuery, GetSecondDepthCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSecondDepthCategoriesQuery, GetSecondDepthCategoriesQueryVariables>(GetSecondDepthCategoriesDocument, options);
      }
export function useGetSecondDepthCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSecondDepthCategoriesQuery, GetSecondDepthCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSecondDepthCategoriesQuery, GetSecondDepthCategoriesQueryVariables>(GetSecondDepthCategoriesDocument, options);
        }
export type GetSecondDepthCategoriesQueryHookResult = ReturnType<typeof useGetSecondDepthCategoriesQuery>;
export type GetSecondDepthCategoriesLazyQueryHookResult = ReturnType<typeof useGetSecondDepthCategoriesLazyQuery>;
export type GetSecondDepthCategoriesQueryResult = Apollo.QueryResult<GetSecondDepthCategoriesQuery, GetSecondDepthCategoriesQueryVariables>;
export const GetSecondDepthCategoryDocument = gql`
    query getSecondDepthCategory($args: SecondDepthCategoryWhereUniqueInput!, $catalogWhere: CategoryWhereCatalogParamsInput) @api(name: cloud) {
  secondDepthCategory(args: $args, catalogWhere: $catalogWhere) {
    ...SecondDepthCatalogCategory
  }
}
    ${SecondDepthCatalogCategoryFragmentDoc}`;

/**
 * __useGetSecondDepthCategoryQuery__
 *
 * To run a query within a React component, call `useGetSecondDepthCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSecondDepthCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSecondDepthCategoryQuery({
 *   variables: {
 *      args: // value for 'args'
 *      catalogWhere: // value for 'catalogWhere'
 *   },
 * });
 */
export function useGetSecondDepthCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetSecondDepthCategoryQuery, GetSecondDepthCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSecondDepthCategoryQuery, GetSecondDepthCategoryQueryVariables>(GetSecondDepthCategoryDocument, options);
      }
export function useGetSecondDepthCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSecondDepthCategoryQuery, GetSecondDepthCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSecondDepthCategoryQuery, GetSecondDepthCategoryQueryVariables>(GetSecondDepthCategoryDocument, options);
        }
export type GetSecondDepthCategoryQueryHookResult = ReturnType<typeof useGetSecondDepthCategoryQuery>;
export type GetSecondDepthCategoryLazyQueryHookResult = ReturnType<typeof useGetSecondDepthCategoryLazyQuery>;
export type GetSecondDepthCategoryQueryResult = Apollo.QueryResult<GetSecondDepthCategoryQuery, GetSecondDepthCategoryQueryVariables>;
export const GetThirdDepthCategoriesDocument = gql`
    query getThirdDepthCategories @api(name: cloud) {
  thirdDepthCategories {
    ...ThirdDepthCatalogCategories
  }
}
    ${ThirdDepthCatalogCategoriesFragmentDoc}`;

/**
 * __useGetThirdDepthCategoriesQuery__
 *
 * To run a query within a React component, call `useGetThirdDepthCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThirdDepthCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThirdDepthCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetThirdDepthCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetThirdDepthCategoriesQuery, GetThirdDepthCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThirdDepthCategoriesQuery, GetThirdDepthCategoriesQueryVariables>(GetThirdDepthCategoriesDocument, options);
      }
export function useGetThirdDepthCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThirdDepthCategoriesQuery, GetThirdDepthCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThirdDepthCategoriesQuery, GetThirdDepthCategoriesQueryVariables>(GetThirdDepthCategoriesDocument, options);
        }
export type GetThirdDepthCategoriesQueryHookResult = ReturnType<typeof useGetThirdDepthCategoriesQuery>;
export type GetThirdDepthCategoriesLazyQueryHookResult = ReturnType<typeof useGetThirdDepthCategoriesLazyQuery>;
export type GetThirdDepthCategoriesQueryResult = Apollo.QueryResult<GetThirdDepthCategoriesQuery, GetThirdDepthCategoriesQueryVariables>;
export const GetThirdDepthCategoryDocument = gql`
    query getThirdDepthCategory($args: ThirdDepthCategoryWhereUniqueInput!, $catalogWhere: CategoryWhereCatalogParamsInput) @api(name: cloud) {
  thirdDepthCategory(args: $args, catalogWhere: $catalogWhere) {
    ...ThirdDepthCatalogCategory
  }
}
    ${ThirdDepthCatalogCategoryFragmentDoc}`;

/**
 * __useGetThirdDepthCategoryQuery__
 *
 * To run a query within a React component, call `useGetThirdDepthCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThirdDepthCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThirdDepthCategoryQuery({
 *   variables: {
 *      args: // value for 'args'
 *      catalogWhere: // value for 'catalogWhere'
 *   },
 * });
 */
export function useGetThirdDepthCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetThirdDepthCategoryQuery, GetThirdDepthCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThirdDepthCategoryQuery, GetThirdDepthCategoryQueryVariables>(GetThirdDepthCategoryDocument, options);
      }
export function useGetThirdDepthCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThirdDepthCategoryQuery, GetThirdDepthCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThirdDepthCategoryQuery, GetThirdDepthCategoryQueryVariables>(GetThirdDepthCategoryDocument, options);
        }
export type GetThirdDepthCategoryQueryHookResult = ReturnType<typeof useGetThirdDepthCategoryQuery>;
export type GetThirdDepthCategoryLazyQueryHookResult = ReturnType<typeof useGetThirdDepthCategoryLazyQuery>;
export type GetThirdDepthCategoryQueryResult = Apollo.QueryResult<GetThirdDepthCategoryQuery, GetThirdDepthCategoryQueryVariables>;